/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateAPIKeyForUserOptions,
  CreateAPIKeyForUserStatus201,
  CreateAPIKeyForUserStatus404,
  CreateAPIKeyForUserStatus500,
} from '../types/CreateAPIKeyForUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createAPIKeyForUser } from '../clients/createAPIKeyForUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createAPIKeyForUserMutationKey = () => [{ url: '/v1/user/apikey' }] as const

export function createAPIKeyForUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createAPIKeyForUserMutationKey()
  return mutationOptions<
    CreateAPIKeyForUserStatus201,
    ResponseErrorConfig<CreateAPIKeyForUserStatus404 | CreateAPIKeyForUserStatus500>,
    CreateAPIKeyForUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createAPIKeyForUser({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create apikey for a user
 * {@link /v1/user/apikey}
 */
export function useCreateAPIKeyForUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateAPIKeyForUserStatus201,
      ResponseErrorConfig<CreateAPIKeyForUserStatus404 | CreateAPIKeyForUserStatus500>,
      CreateAPIKeyForUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createAPIKeyForUserMutationKey()

  const baseOptions = createAPIKeyForUserMutationOptions(config) as UseMutationOptions<
    CreateAPIKeyForUserStatus201,
    ResponseErrorConfig<CreateAPIKeyForUserStatus404 | CreateAPIKeyForUserStatus500>,
    CreateAPIKeyForUserOptions,
    TContext
  >

  return useMutation<
    CreateAPIKeyForUserStatus201,
    ResponseErrorConfig<CreateAPIKeyForUserStatus404 | CreateAPIKeyForUserStatus500>,
    CreateAPIKeyForUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateAPIKeyForUserStatus201,
    ResponseErrorConfig<CreateAPIKeyForUserStatus404 | CreateAPIKeyForUserStatus500>,
    CreateAPIKeyForUserOptions,
    TContext
  >
}
